import React from 'react';
import './src/global.css';
import { ThemeProvider } from './src/context/ThemeContext';
import analyticsService from './src/services/analytics';

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);

export const onClientEntry = () => {
  analyticsService.init();
};
